import { useRef } from 'react';
import { RunnerAction } from './RunnerAction';

const ACTION_SX = { width: 'fit-content', maxWidth: 'min(280px, 100%)', minHeight: 44, display: 'flex', mx: 'auto', px: 2, py: 1, borderRadius: '8px', whiteSpace: 'normal', overflowWrap: 'anywhere' } as const;
export const PRIMARY_SX = { ...ACTION_SX, color: '#fff', backgroundColor: '#F67A1A', '&:hover': { backgroundColor: '#d9670f' }, fontWeight: 700 } as const;
export const SECONDARY_SX = { ...ACTION_SX, backgroundColor: '#fff', borderColor: '#d0d5dd', color: '#1f2937', fontWeight: 700 } as const;

/** Hidden file input behind a DSL Button. `capture` asks a phone for the camera. */
export function PickButton({ label, onFile, capture, primary, disabled, dataTestId, accept = "image/jpeg,image/png,image/webp,image/heic" }: {
  label: string;
  accept?: string;
  onFile: (f: File) => void;
  capture?: boolean;
  primary?: boolean;
  disabled?: boolean;
  dataTestId?: string;
}) {
  const ref = useRef<HTMLInputElement | null>(null);
  return (
    <>
      <RunnerAction
        ariaLabel={label}
        buttonText={label}
        dataTestId={dataTestId}
        size="small"
        topic="account" appearance={primary ? 'primary' : 'outline'}
        disabled={disabled}
        onClick={() => ref.current?.click()}
      />
      <input
        ref={ref}
        type="file"
        accept={accept}
        {...(capture ? { capture: 'user' as const } : {})}
        style={{ display: 'none' }}
        aria-hidden
        tabIndex={-1}
        data-testid={dataTestId ? `${dataTestId}-input` : undefined}
        onChange={(e) => {
          const f = e.target.files?.[0];
          // Reset so picking the SAME file twice still fires a change event.
          e.target.value = '';
          if (f) onFile(f);
        }}
      />
    </>
  );
}
